import { react, useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import HeaderSlogan from './HeaderSlogan';
import Button from '@mui/material/Button';
import Image from 'mui-image';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DriverSignupWizard from './DriverSignup/DriverSignupWizard'
import Diversity1Icon from '@mui/icons-material/Diversity1';
import ScheduleIcon from '@mui/icons-material/Schedule';

import ReactGA from 'react-ga4';
ReactGA.initialize([{ trackingId: process.env.REACT_APP_GOOGLE_TAG }]);

const SignUp = () => {
    const [showDriverSignup, setShowDriverSignup] = useState(false);

    useEffect(() => {
        if (window.location.href.indexOf('localhost') == -1 && window.location.href.toLowerCase().indexOf('test.sipzee.com') == -1) {
            ReactGA.send({ hitType: "pageview", page: '/SignUp' });
        }
    }, []);

    let driverSignupPanel = null;
    if (showDriverSignup) {

        return <DriverSignupWizard Cancel={() => setShowDriverSignup(false)} />

    }
    else {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: '10px' }}>
                <div style={{ marginTop: '15px', alignSelf: 'center', maxWidth: '600px' }}>
                    <HeaderSlogan />
                    <div>
                        <div style={{ color: 'var(--sipzee-yellow)', textAlign: 'left', fontWeight: 'bold', marginBottom: '10px' }} >Become a Sipzee Recycler</div>

                        <div style={{textAlign:'left'} }>
                            <div style={{ fontWeight: 'bold' }}>Be your own Boss</div>
                            <div style={{ marginLeft: '25px', display:'flex' }}>
                                <ScheduleIcon sx={{ color: 'var(--sipzee-green)', fontSize: 50 }} />
                                <div style={{ marginLeft: '5px' }}>Work part time or full time - any time. Set your own hours for a completely flexible schedule.</div>
                            </div>
                        </div>

                        <div style={{ textAlign: 'left', marginTop:'15px' }}>
                            <div style={{ fontWeight: 'bold' }}>Get Paid</div>
                            <div style={{ marginLeft: '25px', display: 'flex' }}>
                                <img src='/images/payout.png' style={{ width: '60px', alignSelf: 'center' }} />
                                <div style={{ marginLeft: '5px' }}>Purchase cans/bottles for 6&#162; and get paid 10&#162; per unit in cash after recycling them. Efficient recyclers can make $20+ per hour.</div>
                            </div>
                        </div>

                        <div style={{ textAlign: 'left', marginTop: '15px' }}>
                            <div style={{ fontWeight: 'bold' }}>Control your Geography</div>
                            <div style={{ marginLeft: '25px', display: 'flex' }}>
                                <LocationOnIcon sx={{ color: 'var(--sipzee-green)', fontSize: 50 }} />
                                <div style={{ marginLeft: '5px' }}>Add zip codes or circle areas on a digital map that you'd like to provide recycling services for.</div>
                            </div>
                        </div>

                        <div style={{ textAlign: 'left', marginTop: '15px' }}>
                            <div style={{ fontWeight: 'bold' }}>Support your Community</div>
                            <div style={{ marginLeft: '25px', display: 'flex' }}>
                                <Diversity1Icon sx={{ color: 'var(--sipzee-green)', fontSize: 50 }} />
                                <div style={{ marginLeft: '5px' }}>Help reduce opportunities for spread of COVID-19 virus by reducing congestion in store recycling center.</div>
                            </div>
                        </div>

                        <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'center' }}>
                            <img src="images/Michigan.png" style={{ width:'100px', height:'100px', maxWidth: '100px', maxHeight: '100px' }} />
                            <div style={{ alignSelf: 'center', marginLeft: '10px' }}>Sipzee is only servicing Michigan at this time.</div>
                        </div>
                        <Button color="sipzeeYellow" variant="contained" onClick={(e) => setShowDriverSignup(true)} >Sign Up</Button>

                        

                    </div>
                </div>
            </div>
        )
    }

    
}

export default SignUp;